module.exports = __webpack_public_path__ + "static/media/TRADIES_MAIN_1500x800-min.148e2dfa.jpg";